// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-dropdown-docs',
    templateUrl: './dropdown.docs.generated.html',
})
export class UIDropdownDocs { }
